//手机号分段显示，如 13934235567 =>  139 3423 5567
function phoneByGroup(phone) {
    phone = (phone+'').replace(/\s/g, '');
    let len = phone.length;
    if(len <4) {
        return phone;
    }
    if(len >=4) {
        phone = phone.substr(0, 3) + ' ' + phone.substr(3);
    }
    if(len >=8) {
        phone = phone.substr(0, 8) + ' ' + phone.substr(8);
    }
    return phone;
}

//分转元，返回千分符格式
function fen2Yuan(num) {
    if(!num) {
      num = 0;
    }
    let numStr   = (num*0.01).toFixed(2) + '';
    let reg = numStr.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;//千分符的正则
    numStr = numStr.replace(reg, '$1,');
    return numStr;
 }

//车牌号格式化，如： 粤XAA789 =》 粤X.AA789
function carNumberFormat(carnumber='') {
    if (!carnumber) return '';
    return carnumber.substr(0,2) + '·' + carnumber.substr(2);
}

// 替换富文本中的所有a链接
function replaceRichALink(str){
    return str;  //PS: 之前是采用iframe显示H5内页，该方案废弃掉，直接页面H5跳转
    var reg = new RegExp(/href="(.*?)"/,'gi');
    str = str.replace(reg, " data-link='$1' attribute=\"$1\"");
    return str
}

function transformTextToHtml(str){
    let reg = /\n/g
    str = str.replace(reg,'<br />')
    return str
}

// H5评论带emoji后端报错，将评论中的emoji转换
function utf16toEmoji(str){
    var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则 
    str = str.replace(patt, function(char) {
        var H, L, code;
        if (char.length === 2) {
            H = char.charCodeAt(0);
            // 取出高位 
            L = char.charCodeAt(1);
            // 取出低位 
            code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00;
            //转换算法
            return "&#" + code + ";";
        } else {
            return char;
        }
    });
    return str;
  }

// 从云端获取的评论中如果有表情，需要转化
function emojiToutf16(str){
    var strObj=utf16toEmoji(str);
    var patt = /&#\d+;/g;
    var H,L,code;
    var arr = strObj.match(patt)||[];
    for (var i=0;i<arr.length;i++){
        code = arr[i];
        code=code.replace('&#','').replace(';','');
        // 高位
        H = Math.floor((code-0x10000) / 0x400)+0xD800;
        // 低位
        L = (code - 0x10000) % 0x400 + 0xDC00;
        code = "&#"+code+";";
        var s = String.fromCharCode(H,L);
        strObj = strObj.replace(code,s);
    }
    return strObj;
  }

export {
    phoneByGroup,
    fen2Yuan,
    carNumberFormat,
    replaceRichALink,
    transformTextToHtml,
    utf16toEmoji,
    emojiToutf16
}


// WEBPACK FOOTER //
// ./src/utils/filter.js